import ActionTypes from '../actions/types';
import StatusTypes from '../store/types';

function trainingReducer(state = {}, action) {
  console.log('trainingReducer() action: ', action);
  const { error, response } = action;

  switch (action.type) {
    case ActionTypes.GET_WORKOUTS_REQUEST:
      return { ...state, status: StatusTypes.getWorkoutsPending };
    case ActionTypes.GET_WORKOUTS_SUCCESS:
      return { ...state, status: StatusTypes.getWorkoutsSuccess, workouts: response };
    case ActionTypes.GET_WORKOUTS_FAIL:
      return { ...state, status: StatusTypes.getWorkoutsFail, error };
    case ActionTypes.GET_WORKOUT_REQUEST:
      return { ...state, status: StatusTypes.getWorkoutPending };
    case ActionTypes.GET_WORKOUT_SUCCESS:
      return { ...state, status: StatusTypes.getWorkoutSuccess, workout: response };
    case ActionTypes.GET_WORKOUT_FAIL:
      return { ...state, status: StatusTypes.getWorkoutFail, error };
    case ActionTypes.GET_EXERCISES_REQUEST:
      return { ...state, status: StatusTypes.getExercisesPending };
    case ActionTypes.GET_EXERCISES_SUCCESS:
      return { ...state, status: StatusTypes.getExercisesSuccess, exercises: response };
    case ActionTypes.GET_EXERCISES_FAIL:
      return { ...state, status: StatusTypes.getExercisesFail, error };
    case ActionTypes.RESET_STATUS:
      return { ...state, status: undefined, error: undefined };
    default:
      return state;
  }
}

export default trainingReducer;
